module.exports = __webpack_public_path__ + "img/ppjs.322bd344.png";